import React, { useState } from "react";
import { Checkbox, FormControlLabel, TextField } from "@mui/material";
import "./DataTagFileSearch.scss";

const DataTagPopupUserFilter = ({
  users = [],
  selectedValues = [],
  onApply,
}) => {
  const [search, setSearch] = useState("");

  const isObjectMode =
    users.length > 0 && typeof users[0] === "object";

  const getLabel = (item) =>
    isObjectMode ? item.username : item;

  const getValue = (item) =>
    isObjectMode ? item.id : item;

  const toggleSelected = (item) => {
    const value = getValue(item);

    const exists = selectedValues.some((x) =>
      isObjectMode ? x.id === value : x === value,
    );

    const next = exists
      ? selectedValues.filter((x) =>
          isObjectMode ? x.id !== value : x !== value,
        )
      : [...selectedValues, item];

    onApply?.(next);
  };

  const filteredUsers = users.filter((item) =>
    getLabel(item)
      ?.toLowerCase()
      .includes(search.toLowerCase()),
  );

  return (
    <div className="data-tag-file-search-container">
      <TextField
        fullWidth
        size="small"
        placeholder="Search users..."
        value={search}
        variant="outlined"
        autoFocus
        className="search-input"
        onChange={(e) => {
          setSearch(e.target.value);
        }}
      />

      <div className="data-tag-file-list">
        {filteredUsers.length > 0 ? (
          filteredUsers.map((item) => {
            const value = getValue(item);
            const label = getLabel(item);

            const checked = selectedValues.some((x) =>
              isObjectMode ? x.id === value : x === value,
            );

            return (
              <FormControlLabel
                key={value}
                className="file-item"
                control={
                  <Checkbox
                    size="small"
                    checked={checked}
                    onChange={() => toggleSelected(item)}
                  />
                }
                label={label}
              />
            );
          })
        ) : (
          <p className="no-data">No users found</p>
        )}
      </div>
    </div>
  );
};

export default DataTagPopupUserFilter;